// here to give path when require.resolve is used by our consumer
export const LIBRARY = 'TRIDENT_UI';
